import { createContext, useContext, useMemo, useState } from "react";
import { COUNTRY_OPTIONS } from "./utils/mapers";

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const [country, setCountry] = useState("chile");

  const value = useMemo(
    () => ({ country, setCountry, options: COUNTRY_OPTIONS }),
    [country]
  );

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountryFilter() {
  const ctx = useContext(CountryContext);

  if (!ctx) {
    throw new Error("useCountryFilter must be used within CountryProvider");
  }

  return ctx;
}